import { marker as T } from '@biesbjerg/ngx-translate-extract-marker';

export const helptextAbout = {
  help: T('Looking for help?'),

  docs: T('The <a href="https://www.truenas.com/docs/" target="_blank">TrueNAS Documentation Site</a> \
is a collaborative website with helpful guides and information about your new storage system.'),

  forums: T('The <a href="https://forums.truenas.com/" target="_blank" class="external-link">TrueNAS Community Forums</a> \
are the best place to ask questions and interact with fellow TrueNAS users.'),

  newsLetter: T('You can join the <a href="https://www.truenas.com/newsletter/" target="_blank" class="external-link">TrueNAS Newsletter</a> \
for monthly updates and latest developments.'),

  contact: T('Does your business need <a href="https://www.ixsystems.com/truenas/?utm_source=truenas+core+ui&utm_medium=os&utm_campaign=welcome" \
target="_blank">Enterprise level</a> support and services? Contact \
<a href="https://www.ixsystems.com/quote-form/?utm_source=truenas+core+ui&utm_medium=os&utm_campaign=welcome"\
target="_blank">iXsystems</a> for more information.'),

  opensource: T('TrueNAS {product} is Free and <a href="https://github.com/truenas/" target="_blank"> \
Open Source</a> software, which is provided as-is with no warranty.'),

  actionBtnText: {
    about: T('Close'),
  },
};
